import React from 'react';
import { useCameraScanner } from './useCameraScanner';

export function withCameraScanner(location, hookOptions = {}) {
  return function (WrappedComponent) {
    function WithCameraScannerWrapper(props) {
      const navigation = props.navigation || null;
      const camera = useCameraScanner(location, {
        ...hookOptions,
        navigation,
      });

      return <WrappedComponent {...props} cameraHook={camera} />;
    }

    WithCameraScannerWrapper.displayName = `WithCameraScanner(${
      WrappedComponent.displayName || WrappedComponent.name || 'Component'
    })`;
    return WithCameraScannerWrapper;
  };
}
